import {
  BadgeCheck,
  ShieldCheck,
  HardHat,
  Award,
  Users,
  MapPin,
  CalendarClock,
  CreditCard,
  Siren,
  Wrench,
  RefreshCw,
  House,
  Building2,
  PanelTop,
  Layers,
  Layers3,
  CloudLightning,
  Droplets,
  LayoutPanelLeft,
  Ruler,
  Wind,
  ClipboardCheck,
  Hammer,
} from "lucide-react";

export const iconMap = {
  BadgeCheck,
  ShieldCheck,
  HardHat,
  Award,
  Users,
  MapPin,
  CalendarClock,
  CreditCard,
  Siren,
  Wrench,
  RefreshCw,
  House,
  Building2,
  PanelTop,
  Layers,
  Layers3,
  CloudLightning,
  Droplets,
  LayoutPanelLeft,
  Ruler,
  Wind,
  ClipboardCheck,
  Hammer,
};

export function Icon({ name, ...props }) {
  const Cmp = iconMap[name] || Hammer;
  return <Cmp {...props} />;
}
